var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',[_c('b-select',_vm._b({attrs:{"value":_vm.value,"expanded":""},on:{"change":function($event){return _vm.$emit('change')},"input":_vm.onInput}},'b-select',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }